<template>
  <div>
    <div v-show="graphLoading" class="graph-loader">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      />
    </div>
    <div v-show="!graphLoading">
      <v-chip-group>
        <v-chip
            v-for="(entity) in Object.keys(seriesEnabled)"
            @click="switchSeries(entity, seriesEnabled[entity].text)"
            :color="seriesIndexes[seriesEnabled[entity].text] === -1 ? '' : chartOptions.colors[seriesIndexes[seriesEnabled[entity].text]]"
            :class="{ 'text-regular': true, 'white--text': seriesEnabled[entity].isEnabled }"
            large
            :key="entity"
            :outlined="!seriesEnabled[entity].isEnabled"
        >
          {{ seriesEnabled[entity].text }} {{totals[entity] || '-'}}
        </v-chip>
      </v-chip-group>
      <apexchart ref="mainchart" type="line" height="300px"
                 :options="chartOptions"
                 :series="series"/>
      <div class="chart-values">
        <v-simple-table class="chart-values-table">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left accent--text">
                Date ({{prettyTimezone()}})
              </th>
              <th
                v-for="(entity) in Object.keys(seriesEnabled)"
                v-if="seriesEnabled[entity].isEnabled"
                :style="`background-color: ${chartOptions.colors[seriesIndexes[seriesEnabled[entity].text]]}`"
                class="text-left white--text"
              >
                {{seriesEnabled[entity].text}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-center">{{seriesValues.x.value}}</td>
              <td v-for="entity in Object.keys(seriesEnabled)" v-if="seriesEnabled[entity].isEnabled">
                <div class="d-flex justify-space-between">
                  <div class="report-value">{{seriesValues[entity].value}}</div>
                  <div v-if="isCompared" class="report-comparison">
                    <span :class="`${seriesValues[entity].comparison >= 0 ? 'success' : 'error'}--text`">
                      ({{seriesValues[entity].comparison}}%)
                    </span>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="isCompared">
              <td class="text-center red--text">{{ seriesValues.x.comparison }}</td>
              <td v-for="entity in Object.keys(seriesEnabled)" v-if="seriesEnabled[entity].isEnabled">
                <div class="d-flex justify-space-between">
                  <div class="report-value red--text">{{seriesValues[entity].comparedData}}</div>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { DateTime } from 'luxon';
import timezones from 'timezones-list';
import {mapGetters} from "vuex";

function updateCurrenValues({ series, seriesIndex, dataPointIndex, w }) {
  const config = {
    seriesValues: {
      x: {
        value: '',
        comparison: '',
      },
      uvs: { value: 0, comparison: '' },
      clicks: { value: 0, comparison: '' },
      /*impressions: { value: 0, comparison: '' },
      impTp: { value: 0, comparison: '' },
      registrations: { value: 0, comparison: '' },
      regTp: { value: 0, comparison: '' },*/
      conversions: { value: 0, comparison: '' },
      //convTp: { value: 0, comparison: '' },
      epc: { value: 0, comparison: '' },
      avg_cost: { value: 0, comparison: '' },
      cost: { value: 0, comparison: '' },
      revenue: { value: 0, comparison: '' },
      margin: { value: 0, comparison: '' },
      profit: { value: 0, comparison: '' },
      sales_ratio: { value: 0, comparison: '' },
      uvs_sales_ratio: { value: 0, comparison: '' },
    },
  };
  config.seriesValues.x.value = typeof w.globals.categoryLabels[dataPointIndex] === 'string'
      ? DateTime.fromISO(w.globals.categoryLabels[dataPointIndex]).toFormat('MMMM, d')
      : DateTime.fromISO(this.chartOptions.xaxis.categories[dataPointIndex]).toFormat('MMMM, d');

  if (this.compDates?.length > 0) {
    config.seriesValues.x.comparison = (DateTime.fromISO(this.compDates[dataPointIndex]).toFormat('MMMM, d'));
  }

  if (this.seriesIndexes['UVs'] !== -1 && series[this.seriesIndexes['UVs']][dataPointIndex] !== undefined) {
    config.seriesValues.uvs.value = Number(series[this.seriesIndexes['UVs']][dataPointIndex]) || 0;
    if (series[this.seriesIndexes['UVs'] + 1] && series[this.seriesIndexes['UVs'] + 1][dataPointIndex] === 0) {
      config.seriesValues.uvs.comparison = 0;
    } else if (series[this.seriesIndexes['UVs'] + 1]) {
      config.seriesValues.uvs.comparedData = Number(series[this.seriesIndexes['UVs'] + 1][dataPointIndex]) || 0;
      config.seriesValues.uvs.comparison = Math.round((
          (Number(series[this.seriesIndexes['UVs']][dataPointIndex]) / Number(series[this.seriesIndexes['UVs'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }

  if (this.seriesIndexes['Clicks'] !== -1 && series[this.seriesIndexes['Clicks']][dataPointIndex] !== undefined) {
    config.seriesValues.clicks.value = Number(series[this.seriesIndexes['Clicks']][dataPointIndex]) || 0;
    if (series[this.seriesIndexes['Clicks'] + 1] && series[this.seriesIndexes['Clicks'] + 1][dataPointIndex] === 0) {
      config.seriesValues.clicks.comparison = 0;
    } else if (series[this.seriesIndexes['Clicks'] + 1]) {
      config.seriesValues.clicks.comparedData = Number(series[this.seriesIndexes['Clicks'] + 1][dataPointIndex]) || 0;
      config.seriesValues.clicks.comparison = Math.round((
          (Number(series[this.seriesIndexes['Clicks']][dataPointIndex]) / Number(series[this.seriesIndexes['Clicks'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  /*if (series[2][dataPointIndex] !== undefined) {
    config.seriesValues.impressions.value = Number(series[2][dataPointIndex]) || 0;
    if (series[18] && series[18][dataPointIndex] === 0) {
      config.seriesValues.impressions.comparison = 0;
    } else if (series[18]) {
      config.seriesValues.impressions.comparison = Math.round((
          (Number(series[2][dataPointIndex]) / Number(series[18][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (series[3][dataPointIndex] !== undefined) {
    config.seriesValues.impTp.value = `${Number(series[3][dataPointIndex])}%` || '0%';
    if (series[19] && series[19][dataPointIndex] === 0) {
      config.seriesValues.impTp.comparison = 0;
    } else if (series[19]) {
      config.seriesValues.impTp.comparison = Math.round((
          (Number(series[3][dataPointIndex]) / Number(series[19][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (series[4][dataPointIndex] !== undefined) {
    config.seriesValues.registrations.value = Number(series[4][dataPointIndex]) || 0;
    if (series[20] && series[20][dataPointIndex] === 0) {
      config.seriesValues.registrations.comparison = 0;
    } else if (series[20]) {
      config.seriesValues.registrations.comparison = Math.round((
          (Number(series[4][dataPointIndex]) / Number(series[20][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (series[5][dataPointIndex] !== undefined) {
    config.seriesValues.regTp.value = `${Number(series[5][dataPointIndex])}%` || '0%';
    if (series[21] && series[21][dataPointIndex] === 0) {
      config.seriesValues.regTp.comparison = 0;
    } else if (series[21]) {
      config.seriesValues.regTp.comparison = Math.round((
          (Number(series[5][dataPointIndex]) / Number(series[21][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }*/
  if (this.seriesIndexes['Conversions'] !== -1 && series[this.seriesIndexes['Conversions']][dataPointIndex] !== undefined) {
    config.seriesValues.conversions.value = Number(series[this.seriesIndexes['Conversions']][dataPointIndex]) || 0;
    if (series[this.seriesIndexes['Conversions'] + 1] && series[this.seriesIndexes['Conversions'] + 1][dataPointIndex] === 0) {
      config.seriesValues.conversions.comparison = 0;
    } else if (series[this.seriesIndexes['Conversions'] + 1]) {
      config.seriesValues.conversions.comparedData = Number(series[this.seriesIndexes['Conversions'] + 1][dataPointIndex]) || 0;
      config.seriesValues.conversions.comparison = Math.round((
          (Number(series[this.seriesIndexes['Conversions']][dataPointIndex]) / Number(series[this.seriesIndexes['Conversions'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  /*if (series[7][dataPointIndex] !== undefined) {
    config.seriesValues.convTp.value = `${Number(series[7][dataPointIndex])}%` || '0%';
    if (series[23] && series[23][dataPointIndex] === 0) {
      config.seriesValues.convTp.comparison = 0;
    } else if (series[23]) {
      config.seriesValues.convTp.comparison = Math.round((
          (Number(series[7][dataPointIndex]) / Number(series[23][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }*/
  if (this.seriesIndexes['EPC'] !== -1 && series[this.seriesIndexes['EPC']][dataPointIndex] !== undefined) {
    config.seriesValues.epc.value = Number(series[this.seriesIndexes['EPC']][dataPointIndex]) || 0;
    if (series[this.seriesIndexes['EPC'] + 1] && series[this.seriesIndexes['EPC'] + 1][dataPointIndex] === 0) {
      config.seriesValues.epc.comparison = 0;
    } else if (series[this.seriesIndexes['EPC'] + 1]) {
      config.seriesValues.epc.comparedData = Number(series[this.seriesIndexes['EPC'] + 1][dataPointIndex]) || 0;
      config.seriesValues.epc.comparison = Math.round((
          (Number(series[this.seriesIndexes['EPC']][dataPointIndex]) / Number(series[this.seriesIndexes['EPC'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (this.seriesIndexes['Avg. Cost'] !== -1 && series[this.seriesIndexes['Avg. Cost']][dataPointIndex] !== undefined) {
    config.seriesValues.avg_cost.value = `$${Number(series[this.seriesIndexes['Avg. Cost']][dataPointIndex])}` || '$0';
    if (series[this.seriesIndexes['Avg. Cost'] + 1] && series[this.seriesIndexes['Avg. Cost'] + 1][dataPointIndex] === 0) {
      config.seriesValues.avg_cost.comparison = 0;
    } else if (series[this.seriesIndexes['Avg. Cost'] + 1]) {
      config.seriesValues.clicks.comparedData = Number(series[this.seriesIndexes['Clicks'] + 1][dataPointIndex]) || 0;
      config.seriesValues.avg_cost.comparison = Math.round((
          (Number(series[this.seriesIndexes['Avg. Cost']][dataPointIndex]) / Number(series[this.seriesIndexes['Avg. Cost'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (this.seriesIndexes['Cost'] !== -1 && series[this.seriesIndexes['Cost']][dataPointIndex] !== undefined) {
    config.seriesValues.cost.value = `$${Number(series[this.seriesIndexes['Cost']][dataPointIndex])}` || '$0';
    if (series[this.seriesIndexes['Cost'] + 1] && series[this.seriesIndexes['Cost'] + 1][dataPointIndex] === 0) {
      config.seriesValues.cost.comparison = 0;
    } else if (series[this.seriesIndexes['Cost'] + 1]) {
      config.seriesValues.cost.comparedData = Number(series[this.seriesIndexes['Cost'] + 1][dataPointIndex]) || 0;
      config.seriesValues.cost.comparison = Math.round((
          (Number(series[this.seriesIndexes['Cost']][dataPointIndex]) / Number(series[this.seriesIndexes['Cost'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (this.seriesIndexes['Revenue'] !== -1 && series[this.seriesIndexes['Revenue']][dataPointIndex] !== undefined) {
    config.seriesValues.revenue.value = `$${Number(series[this.seriesIndexes['Revenue']][dataPointIndex])}` || '$0';
    if (series[this.seriesIndexes['Revenue'] + 1] && series[this.seriesIndexes['Revenue'] + 1][dataPointIndex] === 0) {
      config.seriesValues.revenue.comparison = 0;
    } else if (series[this.seriesIndexes['Revenue'] + 1]) {
      config.seriesValues.revenue.comparedData = Number(series[this.seriesIndexes['Revenue'] + 1][dataPointIndex]) || 0;
      config.seriesValues.revenue.comparison = Math.round((
          (Number(series[this.seriesIndexes['Revenue']][dataPointIndex]) / Number(series[this.seriesIndexes['Revenue'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (this.seriesIndexes['Margin'] !== -1 && series[this.seriesIndexes['Margin']][dataPointIndex] !== undefined) {
    config.seriesValues.margin.value = `${Number(series[this.seriesIndexes['Margin']][dataPointIndex])}%` || '0%';
    if (series[this.seriesIndexes['Margin'] + 1] && series[this.seriesIndexes['Margin'] + 1][dataPointIndex] === 0) {
      config.seriesValues.margin.comparison = 0;
    } else if (series[this.seriesIndexes['Margin'] + 1]) {
      config.seriesValues.margin.comparedData = Number(series[this.seriesIndexes['Margin'] + 1][dataPointIndex]) || 0;
      config.seriesValues.margin.comparison = Math.round((
          (Number(series[this.seriesIndexes['Margin']][dataPointIndex]) / Number(series[this.seriesIndexes['Margin'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (this.seriesIndexes['Profit'] !== -1 && series[this.seriesIndexes['Profit']][dataPointIndex] !== undefined) {
    config.seriesValues.profit.value = `$${Number(series[this.seriesIndexes['Profit']][dataPointIndex])}` || '$0';
    if (series[this.seriesIndexes['Profit'] + 1] && series[this.seriesIndexes['Profit'] + 1][dataPointIndex] === 0) {
      config.seriesValues.profit.comparison = 0;
    } else if (series[this.seriesIndexes['Profit'] + 1]) {
      config.seriesValues.profit.comparedData = Number(series[this.seriesIndexes['Profit'] + 1][dataPointIndex]) || 0;
      config.seriesValues.profit.comparison = Math.round((
          (Number(series[this.seriesIndexes['Profit']][dataPointIndex]) / Number(series[this.seriesIndexes['Profit'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (this.seriesIndexes['Sales Ratio'] !== -1 && series[this.seriesIndexes['Sales Ratio']][dataPointIndex] !== undefined) {
    config.seriesValues.sales_ratio.value = Number(series[this.seriesIndexes['Sales Ratio']][dataPointIndex]) || 0;
    if (series[this.seriesIndexes['Sales Ratio'] + 1] && series[this.seriesIndexes['Sales Ratio'] + 1][dataPointIndex] === 0) {
      config.seriesValues.sales_ratio.comparison = 0;
    } else if (series[this.seriesIndexes['Sales Ratio'] + 1]) {
      config.seriesValues.sales_ratio.comparedData = Number(series[this.seriesIndexes['Sales Ratio'] + 1][dataPointIndex]) || 0;
      config.seriesValues.sales_ratio.comparison = Math.round((
          (Number(series[this.seriesIndexes['Sales Ratio']][dataPointIndex]) / Number(series[this.seriesIndexes['Sales Ratio'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }
  if (this.seriesIndexes['UVs Sales Ratio'] !== -1 && series[this.seriesIndexes['UVs Sales Ratio']][dataPointIndex] !== undefined) {
    config.seriesValues.uvs_sales_ratio.value = Number(series[this.seriesIndexes['UVs Sales Ratio']][dataPointIndex]) || 0;
    if (series[this.seriesIndexes['UVs Sales Ratio'] + 1] && series[this.seriesIndexes['UVs Sales Ratio'] + 1][dataPointIndex] === 0) {
      config.seriesValues.uvs_sales_ratio.comparison = 0;
    } else if (series[this.seriesIndexes['UVs Sales Ratio'] + 1]) {
      config.seriesValues.uvs_sales_ratio.comparedData = Number(series[this.seriesIndexes['UVs Sales Ratio'] + 1][dataPointIndex]) || 0;
      config.seriesValues.uvs_sales_ratio.comparison = Math.round((
          (Number(series[this.seriesIndexes['UVs Sales Ratio']][dataPointIndex]) / Number(series[this.seriesIndexes['UVs Sales Ratio'] + 1][dataPointIndex])) * 100 - 100
      ) * 100) / 100;
    }
  }

  this.seriesValues = config.seriesValues;

  return '';
}

export default Vue.extend({
  name: 'ReportChart',
  props: {
    isCompared: {
      type: Boolean,
      default: false,
    },
    version: String,
    isDataFetched: {
      type: Boolean,
      default: false,
    },
    drillDownId: {
      default: null,
    },
    reportPeriod: {
      type: String,
      default: 'last7days',
    },
    timezone: String,
    totals: {
      type: Object,
      default: {
        uvs: 0,
        clicks: 0,
        /*impressions: 0,
        impTp: 0,
        registrations: 0,
        regTp: 0,*/
        conversions: 0,
        //convTp: 0,
        epc: 0,
        avg_cost: 0,
        cost: 0,
        revenue: 0,
        margin: 0,
        profit: 0,
        sales_ratio: 0,
        uvs_sales_ratio: 0,
      }
    }
  },
  data: () => ({
    compDates: [],
    seriesValues: {
      x: {
        value: '',
        comparison: '',
      },
      uvs: { value: 0, comparison: '' },
      clicks: { value: 0, comparison: '' },
      /*impressions: { value: 0, comparison: '' },
      impTp: { value: 0, comparison: '' },
      registrations: { value: 0, comparison: '' },
      regTp: { value: 0, comparison: '' },*/
      conversions: { value: 0, comparison: '' },
      //convTp: { value: 0, comparison: '' },
      epc: { value: 0, comparison: '' },
      avg_cost: { value: 0, comparison: '' },
      cost: { value: 0, comparison: '' },
      revenue: { value: 0, comparison: '' },
      margin: { value: 0, comparison: '' },
      profit: { value: 0, comparison: '' },
      sales_ratio: { value: 0, comparison: '' },
      uvs_sales_ratio: { value: 0, comparison: '' },
    },
    seriesEnabled: {
      uvs: {
        isEnabled: true,
        text: 'UVs'
      },
      clicks: {
        isEnabled: false,
        text: 'Clicks'
      },
      /*impressions: {
        isEnabled: true,
        text: 'Impressions'
      },
      impTp: {
        isEnabled: true,
        text: 'Imp.TP'
      },
      registrations: {
        isEnabled: true,
        text: 'Registrations'
      },
      regTp: {
        isEnabled: true,
        text: 'Reg.TP'
      },*/
      conversions: {
        isEnabled: false,
        text: 'Conversions'
      },
      /*convTp: {
        isEnabled: true,
        text: 'Conv.TP'
      },*/
      epc: {
        isEnabled: false,
        text: 'EPC'
      },
      avg_cost: {
        isEnabled: false,
        text: 'Avg. Cost'
      },
      cost: {
        isEnabled: false,
        text: 'Cost'
      },
      revenue: {
        isEnabled: false,
        text: 'Revenue'
      },
      margin: {
        isEnabled: false,
        text: 'Margin'
      },
      profit: {
        isEnabled: false,
        text: 'Profit'
      },
      sales_ratio: {
        isEnabled: false,
        text: 'Sales Ratio'
      },
      uvs_sales_ratio: {
        isEnabled: false,
        text: 'UVs Sales Ratio'
      },
    },
    seriesEnabledClone: '',
    graphLoading: true,
    chartOptions: {
      chart: {
        id: 'reports',
        foreColor: '#BDBDCA',
        toolbar: {
          show: false,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
      },
      xaxis: {
        categories: [],
      },
      grid: {
        position: 'back',
        borderColor: '#f6f6f6',
        row: {
          colors: ['#fbfbfb', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      yaxis: [
        {
          title: {
          },
          labels: {
            formatter: (value) => `$${value}`,
          },
        },
        {
          opposite: true,
          show: false,
        },
      ],
      tooltip: {
        share: true,
        custom: updateCurrenValues.bind(this),
      },
      colors: [],
      stroke: {
        width: [],
        dashArray: [],
      },
      legend: {
        show: false,
      },
    },
    series: [],
    seriesIndexes: {},
    seriesVariations: {
      'UVs': {
        name: 'UVs',
        value: 'uvs',
        data: [],
        color: '#188D83',
      },
      'Clicks': {
        name: 'Clicks',
        value: 'clicks',
        data: [],
        color: '#E4DEAE',
      },
      /*{
        name: 'Impressions',
        value: 'impressions',
        data: [],
      },
      {
        name: 'Imp.TP',
        value: 'impTp',
        data: [],
      },
      {
        name: 'Registrations',
        value: 'registrations',
        data: [],
      },
      {
        name: 'Reg.TP',
        value: 'regTp',
        data: [],
      },*/
      'Conversions': {
        name: 'Conversions',
        value: 'conversions',
        data: [],
        color: '#89CFF0',
      },
      /* {
        name: 'Conv.TP',
        value: 'convTp',
        data: [],
      }, */
      'EPC': {
        name: 'EPC',
        value: 'epc',
        data: [],
        color: '#ffc100',
      },
      'Avg. Cost': {
        name: 'Avg. Cost',
        value: 'avg_cost',
        data: [],
        color: '#ff9a00',
      },
      'Cost': {
        name: 'Cost',
        value: 'cost',
        data: [],
        color: '#ff7400',
      },
      'Revenue': {
        name: 'Revenue',
        value: 'revenue',
        data: [],
        color: '#ff4d00',
      },
      'Margin': {
        name: 'Margin',
        value: 'margin',
        data: [],
        color: '#FFC06E',
      },
      'Profit': {
        name: 'Profit',
        value: 'profit',
        data: [],
        color: '#c7ea46',
      },
      'Sales Ratio': {
        name: 'Sales Ratio',
        value: 'sales_ratio',
        data: [],
        color: '#98fb98',
      },
      'UVs Sales Ratio': {
        name: 'UVs Sales Ratio',
        value: 'uvs_sales_ratio',
        data: [],
        color: '#50c878',
      },
      'Comp UVs': {
        name: 'Comp UVs',
        value: 'uvs_comp',
        data: [],

      },
      'Comp Clicks': {
        name: 'Comp Clicks',
        value: 'clicks_comp',
        data: [],
      },
      'Comp Impressions': {
        name: 'Comp Impressions',
        value: 'impressions_comp',
        data: [],
      },
      'Comp Imp.TP': {
        name: 'Comp Imp.TP',
        value: 'impTp_comp',
        data: [],
      },
      'Comp Registrations': {
        name: 'Comp Registrations',
        value: 'registrations_comp',
        data: [],
      },
      'Comp Reg.TP': {
        name: 'Comp Reg.TP',
        value: 'regTp_comp',
        data: [],
      },
      'Comp Conversions': {
        name: 'Comp Conversions',
        value: 'conversions_comp',
        data: [],
      },
      'Comp Conv.TP': {
        name: 'Comp Conv.TP',
        value: 'convTp_comp',
        data: [],
      },
      'Comp EPC': {
        name: 'Comp EPC',
        value: 'epc_comp',
        data: [],
      },
      'Comp Avg. Cost': {
        name: 'Comp Avg. Cost',
        value: 'avg_cost_comp',
        data: [],
      },
      'Comp Cost': {
        name: 'Comp Cost',
        value: 'cost_comp',
        data: [],
      },
      'Comp Revenue': {
        name: 'Comp Revenue',
        value: 'revenue_comp',
        data: [],
      },
      'Comp Margin': {
        name: 'Comp Margin',
        value: 'margin_comp',
        data: [],
      },
      'Comp Profit': {
        name: 'Comp Profit',
        value: 'profit_comp',
        data: [],
      },
      'Comp Sales Ratio': {
        name: 'Comp Sales Ratio',
        value: 'sales_ratio_comp',
        data: [],
      },
      'Comp UVs Sales Ratio': {
        name: 'Comp UVs Sales Ratio',
        value: 'uvs_sales_ratio_comp',
        data: [],
      },
    }
  }),
  watch: {
    seriesEnabled: {
      deep: true,
      handler: 'updateChartYAxis',
    },
    series() {
      this.seriesIndexes = {}
      if(this.series.length > 0) {
        Object.keys(this.seriesVariations).forEach(value => {
          this.seriesIndexes[this.seriesVariations[value].name] = this.series.findIndex(element => element.value === this.seriesVariations[value].value)
        })
      }
    },
    isDataFetched() {
      this.graphLoading = true;

      this.series = [];
      this.chartOptions.colors = [];
      this.chartOptions.stroke.width = [];
      this.chartOptions.stroke.dashArray = [];
      this.chartOptions.xaxis.categories = [];

      if (this.isDataFetched) {

        if (this.getChartReport[this.drillDownId]) {
          this.prepareData();
        }

        Object.keys(this.seriesEnabled).forEach(value => {
          // console.log(this.seriesEnabled[value].isEnabled, this.seriesEnabled[value].text)
          if(this.seriesEnabled[value].isEnabled === true) {
            this.toggleSeries(this.seriesEnabled[value].text, true)
          }
        })

        this.graphLoading = false;
      }
    }
  },
  created() {
    this.chartOptions = {
      ...this.chartOptions,
      tooltip: {
        share: true,
        custom: updateCurrenValues.bind(this),
      },
    };
  },
  methods: {
    prepareData() {
      this.compDates = this.getChartReport[this.drillDownId].compDates;
      this.chartOptions.xaxis.categories = this.getChartReport[this.drillDownId].dates;
      Object.keys(this.seriesVariations).forEach(key => {
        const entity = this.seriesVariations[key]
        if (entity.data) {
          const underScoreKey = entity.value.split(/(?=[A-Z])/).join('_').toLowerCase();
          entity.data = this.getChartReport[this.drillDownId].data[underScoreKey];
          if (this.isCompared && entity.value.includes('comp') > 0) {
            const key = entity.value.replace('_comp', '');
            entity.data = this.getChartReport[this.drillDownId].comparedData[key];
          } else if (!this.isCompared && entity.value.includes('comp') > 0) {
            let length = this.chartOptions.xaxis.categories.length;
            let index = 0;
            entity.data = [];
            for (index; index < length; index++) {
              entity.data.push(0);
            }
          }
        }
      })
      window.dispatchEvent(new Event('resize'))
    },
    prettyTimezone() {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < timezones.length; i++) {
        if (timezones[i].tzCode === this.timezone) {
          return `UTC ${timezones[i].utc}`;
        }
      }
      return 'UTC +00:00';
    },
    updateChartYAxis() {
      const { yaxis } = this.chartOptions;
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          yaxis,
        },
      };
    },
    switchSeries(name, chartName, newValue = null) {
      this.seriesEnabled[name].isEnabled = newValue === null ? !this.seriesEnabled[name].isEnabled : newValue;
      this.chartOptions.xaxis.categories = this.getChartReport[this.drillDownId].dates;
      this.toggleSeries(chartName, this.seriesEnabled[name].isEnabled);
    },
    toggleSeries(name, isPicked) {
      if (isPicked === false) {
        const indexesToDelete = [];
        this.series.forEach((value, index) => {
          if (value.name === name || value.name === `Comp ${name}`) {
            indexesToDelete.unshift(index)
          }
        })
        indexesToDelete.forEach(index => {
          this.series.splice(index, 1);
          this.chartOptions.colors.splice(index, 1);
          this.chartOptions.stroke.width.splice(index, 1);
          this.chartOptions.stroke.dashArray.splice(index, 1);
        })
      } else {
        this.series.push(this.seriesVariations[name])
        this.chartOptions.colors.push(this.seriesVariations[name].color)
        this.chartOptions.stroke.width.push(2)
        this.chartOptions.stroke.dashArray.push(0)
        this.series.push(this.seriesVariations[`Comp ${name}`])
        this.chartOptions.colors.push(this.seriesVariations[name].color)
        this.chartOptions.stroke.width.push(1)
        this.chartOptions.stroke.dashArray.push(6)
      }
    },
  },
  computed: {
    ...mapGetters('reports', ['getChartReport']),
  }
});
</script>
<style lang="scss" scoped>
.graph-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 315px;
}
</style>
